import React from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentManagementNonNCIPage } from './DocumentManagementNonNCI/DocumentManagementNonNCI.page'

export const DocumentManagementAdditionalDocumentsPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <DocumentManagementNonNCIPage
      documentTitle={t('Profile.Additional documents')}
      showTerms={false}
    />
  )
}
